<div class="card" *ngIf="!loading && data">
  <div class="card-body">
    <div class="row text-left mt-3">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between align-items-center mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">Relatórios & Estatísticas</h1>
          <button class="btn-baixar-pdf" (click)="baixarPdf()" [disabled]="generatingPdf">
            <i class="fa" [ngClass]="generatingPdf ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
            {{ generatingPdf ? 'Gerando PDF...' : 'Baixar PDF' }}
          </button>
        </div>
      </div>
      <div class="col-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Tenha uma visão panorâmica das informações dos servidores na base de dados através dos indicadores e métricas.
        </p>
      </div>
    </div>

    <div class="relatorios-container" #reportContent>

    <!-- ========== VISÃO GERAL ========== -->
  <h5 class="section-title">Visão Geral</h5>
  <div #visaoGeralContent>
  <div class="row cards-row visao-geral-row">
    <div class="col-md-4">
      <div class="card stat-card">
        <div class="card-body">
          <span class="stat-label">Total de Servidores</span>
          <span class="stat-value-lg">{{ formatNumber(totalServidores) }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card stat-card">
        <div class="card-body">
          <span class="stat-label">Distribuição de Servidores</span>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Ativos</span>
            <span class="stat-bar-value">{{ formatNumber(totalActive) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-active" [style.width.%]="getPercent(totalActive, totalServidores)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(totalActive, totalServidores) }}% )</span>
          </div>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Inativos</span>
            <span class="stat-bar-value">{{ formatNumber(totalInactive) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-inactive" [style.width.%]="getPercent(totalInactive, totalServidores)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(totalInactive, totalServidores) }}% )</span>
          </div>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Pensionistas</span>
            <span class="stat-bar-value">{{ formatNumber(totalPensioners) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-pensioners" [style.width.%]="getPercent(totalPensioners, totalServidores)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(totalPensioners, totalServidores) }}% )</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card stat-card">
        <div class="card-body">
          <span class="stat-label">Distribuição por Sexo</span>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Masculino</span>
            <span class="stat-bar-value">{{ formatNumber(totalMaleGeneral) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getPercent(totalMaleGeneral, totalServidores)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(totalMaleGeneral, totalServidores) }}% )</span>
          </div>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Feminino</span>
            <span class="stat-bar-value">{{ formatNumber(totalFemaleGeneral) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="getPercent(totalFemaleGeneral, totalServidores)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(totalFemaleGeneral, totalServidores) }}% )</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
  <!-- fim #visaoGeralContent -->

  <!-- ========== DADOS DOS SERVIDORES ========== -->
  <h5 class="section-title mt-4">Dados dos Servidores</h5>
  <div class="tabs-container">
    <button class="tab-btn" [class.active]="activeTab === 'ativos'" (click)="setActiveTab('ativos')">Servidores Ativos</button>
    <button class="tab-btn" [class.active]="activeTab === 'inativos'" (click)="setActiveTab('inativos')">Servidores Inativos (Aposentados)</button>
    <button class="tab-btn" [class.active]="activeTab === 'pensionistas'" (click)="setActiveTab('pensionistas')">Servidores Pensionistas</button>
  </div>
  <hr class="tabs-divider" />

  <div #tabContent>
  <!-- Dados dos Servidores: layout em 2 colunas -->
  <div class="row cards-row">
    <!-- Coluna esquerda: cards pequenos + gráfico de idade -->
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-6">
          <div class="card stat-card stat-card-85">
            <div class="card-body">
              <span class="stat-label">Servidores {{ tabLabel }}</span>
              <span class="stat-value-lg">{{ formatNumber(currentCount) }}</span>
              <div class="stat-bar-row mt-2">
                <div class="stat-bar-track stat-bar-track-lg"><div class="stat-bar-fill bar-active" [style.width.%]="getPercent(currentCount, totalServidores)"></div></div>
                <span class="stat-bar-pct">( {{ getPercent(currentCount, totalServidores) }}% )</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card stat-card stat-card-85">
            <div class="card-body">
              <span class="stat-label">Distribuição por Sexo</span>
              <div class="stat-bar-row">
                <span class="stat-bar-name">Masculino</span>
                <span class="stat-bar-value">{{ formatNumber(currentMale) }}</span>
                <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getPercent(currentMale, currentCount)"></div></div>
                <span class="stat-bar-pct">( {{ getPercent(currentMale, currentCount) }}% )</span>
              </div>
              <div class="stat-bar-row">
                <span class="stat-bar-name">Feminino</span>
                <span class="stat-bar-value">{{ formatNumber(currentFemale) }}</span>
                <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="getPercent(currentFemale, currentCount)"></div></div>
                <span class="stat-bar-pct">( {{ getPercent(currentFemale, currentCount) }}% )</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card stat-card stat-card-auto mt-3">
        <div class="card-body">
          <span class="stat-label">Distribuição por Idade {{ tabLabel }}</span>
          <div class="age-chart" *ngIf="currentAgeDistribution.length > 0">
            <div class="age-chart-row" *ngFor="let item of currentAgeDistribution">
              <span class="age-chart-label">{{ item.label }}</span>
              <div class="age-chart-bars">
                <div class="age-bar-total" [style.width.%]="getBarPercent(item.count, maxAgeCount)"></div>
                <span class="age-bar-pct" *ngIf="item.count > 0">{{ getPercent(item.count, currentCount) }}%</span>
              </div>
            </div>
            <div class="age-chart-axis">
              <span class="age-chart-axis-spacer"></span>
              <div class="age-chart-axis-ticks">
                <span *ngFor="let tick of ageAxisTicks" class="age-chart-tick">{{ tick }}</span>
              </div>
            </div>
            <div class="age-chart-total">
              <span class="age-chart-total-label">Total</span>
              <span class="age-chart-total-value">{{ formatNumber(totalAgeCount) }}</span>
            </div>
          </div>
          <div *ngIf="currentAgeDistribution.length === 0" class="no-data">Sem dados de idade disponíveis</div>
        </div>
      </div>
    </div>
    <!-- Coluna direita: salário + idade média -->
    <div class="col-md-4 d-flex flex-column">
      <div class="card stat-card stat-card-auto">
        <div class="card-body">
          <span class="stat-label">{{ salaryLabel }} {{ tabLabel }}</span>
          <span class="stat-sublabel">Média Geral</span>
          <span class="stat-value-lg stat-value-currency">{{ formatCurrency(currentAvgSalary) }}</span>
          <hr class="card-divider" />
          <span class="stat-label">Distribuição por Sexo</span>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Masculino</span>
            <span class="stat-bar-value">{{ formatCurrency(currentMaleSalary) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getPercent(currentMaleSalary, currentMaleSalary + currentFemaleSalary)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(currentMale, currentCount) }}% )</span>
          </div>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Feminino</span>
            <span class="stat-bar-value">{{ formatCurrency(currentFemaleSalary) }}</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="getPercent(currentFemaleSalary, currentMaleSalary + currentFemaleSalary)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(currentFemale, currentCount) }}% )</span>
          </div>
        </div>
      </div>
      <div class="card stat-card stat-card-auto mt-3">
        <div class="card-body card-body-compact">
          <span class="stat-label">Idade Média {{ tabLabel }}</span>
          <span class="stat-sublabel">Média Geral</span>
          <div class="age-avg-display">
            <span class="stat-value-lg">{{ round(currentAvgAge) }}</span>
            <span class="stat-unit">Anos</span>
          </div>
          <hr class="card-divider" />
          <span class="stat-label">Distribuição por Sexo</span>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Masculino</span>
            <span class="stat-bar-value">{{ round(currentMaleAge) }} anos</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getPercent(currentMale, currentCount)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(currentMale, currentCount) }}% )</span>
          </div>
          <div class="stat-bar-row">
            <span class="stat-bar-name">Feminino</span>
            <span class="stat-bar-value">{{ round(currentFemaleAge) }} anos</span>
            <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="getPercent(currentFemale, currentCount)"></div></div>
            <span class="stat-bar-pct">( {{ getPercent(currentFemale, currentCount) }}% )</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========== ESTATÍSTICAS SERVIDORES (oculto para pensionistas: não têm cônjuges/dependentes) ========== -->
  <ng-container *ngIf="activeTab !== 'pensionistas'">
  <h5 class="section-title mt-4">Estatísticas Servidores {{ tabLabel }}</h5>

  <!-- INSS / RPPS + Cônjuges + Dependentes (Ativos) -->
  <div class="row cards-row" *ngIf="activeTab === 'ativos'">
    <div class="col-md-4" *ngIf="tempoServicoINSS">
      <div class="card stat-card stat-card-auto">
        <div class="card-body">
          <h6 class="card-stat-titulo">Tempo de Serviço INSS</h6>
          <div class="estatistica-item">
            <span class="estatistica-label">Servidores no INSS</span>
            <div class="estatistica-valor-com-barra">
              <span class="stat-value-lg">{{ tempoServicoINSS.idade_media | number:'1.0-1' }} <small>Anos</small></span>
              <div class="stat-bar-track stat-bar-inline"><div class="stat-bar-fill bar-active" [style.width.%]="tempoServicoINSS.porcentagem"></div></div>
              <span class="stat-bar-pct">( {{ tempoServicoINSS.porcentagem | number:'1.0-1' }}% )</span>
            </div>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Tempo no INSS</span>
            <span class="stat-value-lg">{{ formatNumber(tempoServicoINSS.tempo_medio_dias) }} <small>dias</small></span>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Pct. Médio de Contribuição</span>
            <span class="stat-value-lg">{{ tempoServicoINSS.porcentagem_com_contribuicao | number:'1.0-1' }}%</span>
          </div>
          <div class="estatistica-secao">
            <span class="estatistica-secao-titulo">Estatísticas</span>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Máximo</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoINSS.tempo_maximo_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getBarPercent(tempoServicoINSS.tempo_maximo_dias, tempoServicoINSS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( 100% )</span>
            </div>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Mediana</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoINSS.tempo_mediano_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getBarPercent(tempoServicoINSS.tempo_mediano_dias, tempoServicoINSS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( {{ getBarPercent(tempoServicoINSS.tempo_mediano_dias, tempoServicoINSS.tempo_maximo_dias) }}% )</span>
            </div>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Média</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoINSS.tempo_medio_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-active" [style.width.%]="getBarPercent(tempoServicoINSS.tempo_medio_dias, tempoServicoINSS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( {{ getBarPercent(tempoServicoINSS.tempo_medio_dias, tempoServicoINSS.tempo_maximo_dias) }}% )</span>
            </div>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Mínimo</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoINSS.tempo_minimo_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="getBarPercent(tempoServicoINSS.tempo_minimo_dias, tempoServicoINSS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( {{ getBarPercent(tempoServicoINSS.tempo_minimo_dias, tempoServicoINSS.tempo_maximo_dias) }}% )</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4" *ngIf="tempoServicoRPPS">
      <div class="card stat-card stat-card-auto">
        <div class="card-body">
          <h6 class="card-stat-titulo">Tempo de Serviço RPPS</h6>
          <div class="estatistica-item">
            <span class="estatistica-label">Servidores no RPPS</span>
            <div class="estatistica-valor-com-barra">
              <span class="stat-value-lg">{{ tempoServicoRPPS.idade_media | number:'1.0-1' }} <small>Anos</small></span>
              <div class="stat-bar-track stat-bar-inline"><div class="stat-bar-fill bar-rpps" [style.width.%]="tempoServicoRPPS.porcentagem"></div></div>
              <span class="stat-bar-pct">( {{ tempoServicoRPPS.porcentagem | number:'1.0-1' }}% )</span>
            </div>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Tempo no RPPS</span>
            <span class="stat-value-lg">{{ formatNumber(tempoServicoRPPS.tempo_medio_dias) }} <small>dias</small></span>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Pct. Médio de Contribuição</span>
            <span class="stat-value-lg">{{ tempoServicoRPPS.porcentagem_com_contribuicao | number:'1.0-1' }}%</span>
          </div>
          <div class="estatistica-secao">
            <span class="estatistica-secao-titulo">Estatísticas</span>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Máximo</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoRPPS.tempo_maximo_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-rpps" [style.width.%]="getBarPercent(tempoServicoRPPS.tempo_maximo_dias, tempoServicoRPPS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( 100% )</span>
            </div>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Mediana</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoRPPS.tempo_mediano_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-rpps" [style.width.%]="getBarPercent(tempoServicoRPPS.tempo_mediano_dias, tempoServicoRPPS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( {{ getBarPercent(tempoServicoRPPS.tempo_mediano_dias, tempoServicoRPPS.tempo_maximo_dias) }}% )</span>
            </div>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Média</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoRPPS.tempo_medio_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-rpps" [style.width.%]="getBarPercent(tempoServicoRPPS.tempo_medio_dias, tempoServicoRPPS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( {{ getBarPercent(tempoServicoRPPS.tempo_medio_dias, tempoServicoRPPS.tempo_maximo_dias) }}% )</span>
            </div>
            <div class="stat-bar-row">
              <span class="stat-bar-name">Mínimo</span>
              <span class="stat-bar-value">{{ formatNumber(tempoServicoRPPS.tempo_minimo_dias) }} d.</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-rpps" [style.width.%]="getBarPercent(tempoServicoRPPS.tempo_minimo_dias, tempoServicoRPPS.tempo_maximo_dias)"></div></div>
              <span class="stat-bar-pct">( {{ getBarPercent(tempoServicoRPPS.tempo_minimo_dias, tempoServicoRPPS.tempo_maximo_dias) }}% )</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4" *ngIf="currentConjugesDependentes">
      <div class="card stat-card stat-card-auto">
        <div class="card-body">
          <h6 class="card-stat-titulo">Cônjuges</h6>
          <div class="estatistica-item">
            <span class="estatistica-label">Total de Cônjuges</span>
            <div class="estatistica-valor-com-barra">
              <span class="stat-value-lg">{{ formatNumber(currentConjugesDependentes.total_conjuges) }}</span>
              <div class="stat-bar-track stat-bar-inline"><div class="stat-bar-fill bar-conjuges-dep" [style.width.%]="100"></div></div>
              <span class="stat-bar-pct">( {{ getPercent(currentConjugesDependentes.total_conjuges, currentCount) }}% )</span>
            </div>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Média por Segurado</span>
            <span class="stat-value-lg">{{ currentConjugesDependentes.media_conjuges_por_segurado | number:'1.0-2' }}</span>
          </div>
          <div class="estatistica-secao" *ngIf="currentConjugesDependentes.media_diferenca_idade_conjuge_masculino != null || currentConjugesDependentes.media_diferenca_idade_conjuge_feminino != null">
            <span class="estatistica-secao-titulo">Diferença Idade Servidor</span>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.media_diferenca_idade_conjuge_masculino != null">
              <span class="stat-bar-name">Servidor Masc.</span>
              <span class="stat-bar-value">+ {{ currentConjugesDependentes.media_diferenca_idade_conjuge_masculino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.media_diferenca_idade_conjuge_feminino != null">
              <span class="stat-bar-name">Servidor Fem.</span>
              <span class="stat-bar-value">− {{ currentConjugesDependentes.media_diferenca_idade_conjuge_feminino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card stat-card stat-card-auto mt-3">
        <div class="card-body">
          <h6 class="card-stat-titulo">Dependentes</h6>
          <div class="estatistica-item">
            <span class="estatistica-label">Total de Dependentes</span>
            <div class="estatistica-valor-com-barra">
              <span class="stat-value-lg">{{ formatNumber(currentConjugesDependentes.total_dependentes) }}</span>
              <div class="stat-bar-track stat-bar-inline"><div class="stat-bar-fill bar-conjuges-dep" [style.width.%]="100"></div></div>
              <span class="stat-bar-pct">( {{ getPercent(currentConjugesDependentes.total_dependentes, currentCount) }}% )</span>
            </div>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Média por Segurado</span>
            <span class="stat-value-lg">{{ currentConjugesDependentes.media_dependentes_por_segurado | number:'1.0-2' }}</span>
          </div>
          <div class="estatistica-secao" *ngIf="currentConjugesDependentes.idade_media_dependente != null">
            <span class="estatistica-secao-titulo">Idade Média por Sexo</span>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.idade_media_dependente_masculino != null">
              <span class="stat-bar-name">Masculino</span>
              <span class="stat-bar-value">{{ currentConjugesDependentes.idade_media_dependente_masculino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.idade_media_dependente_feminino != null">
              <span class="stat-bar-name">Feminino</span>
              <span class="stat-bar-value">{{ currentConjugesDependentes.idade_media_dependente_feminino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cônjuges + Dependentes (apenas inativos; pensionistas não têm no sistema) -->
  <div class="row cards-row" *ngIf="activeTab === 'inativos' && currentConjugesDependentes">
    <div class="col-md-4">
      <div class="card stat-card stat-card-auto">
        <div class="card-body">
          <h6 class="card-stat-titulo">Cônjuges</h6>
          <div class="estatistica-item">
            <span class="estatistica-label">Total de Cônjuges</span>
            <div class="estatistica-valor-com-barra">
              <span class="stat-value-lg">{{ formatNumber(currentConjugesDependentes.total_conjuges) }}</span>
              <div class="stat-bar-track stat-bar-inline"><div class="stat-bar-fill bar-conjuges-dep" [style.width.%]="100"></div></div>
              <span class="stat-bar-pct">( {{ getPercent(currentConjugesDependentes.total_conjuges, currentCount) }}% )</span>
            </div>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Média por Segurado</span>
            <span class="stat-value-lg">{{ currentConjugesDependentes.media_conjuges_por_segurado | number:'1.0-2' }}</span>
          </div>
          <div class="estatistica-secao" *ngIf="currentConjugesDependentes.media_diferenca_idade_conjuge_masculino != null || currentConjugesDependentes.media_diferenca_idade_conjuge_feminino != null">
            <span class="estatistica-secao-titulo">Diferença Idade Servidor</span>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.media_diferenca_idade_conjuge_masculino != null">
              <span class="stat-bar-name">Servidor Masc.</span>
              <span class="stat-bar-value">+ {{ currentConjugesDependentes.media_diferenca_idade_conjuge_masculino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.media_diferenca_idade_conjuge_feminino != null">
              <span class="stat-bar-name">Servidor Fem.</span>
              <span class="stat-bar-value">− {{ currentConjugesDependentes.media_diferenca_idade_conjuge_feminino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card stat-card stat-card-auto">
        <div class="card-body">
          <h6 class="card-stat-titulo">Dependentes</h6>
          <div class="estatistica-item">
            <span class="estatistica-label">Total de Dependentes</span>
            <div class="estatistica-valor-com-barra">
              <span class="stat-value-lg">{{ formatNumber(currentConjugesDependentes.total_dependentes) }}</span>
              <div class="stat-bar-track stat-bar-inline"><div class="stat-bar-fill bar-conjuges-dep" [style.width.%]="100"></div></div>
              <span class="stat-bar-pct">( {{ getPercent(currentConjugesDependentes.total_dependentes, currentCount) }}% )</span>
            </div>
          </div>
          <div class="estatistica-item">
            <span class="estatistica-label">Média por Segurado</span>
            <span class="stat-value-lg">{{ currentConjugesDependentes.media_dependentes_por_segurado | number:'1.0-2' }}</span>
          </div>
          <div class="estatistica-secao" *ngIf="currentConjugesDependentes.idade_media_dependente != null">
            <span class="estatistica-secao-titulo">Idade Média por Sexo</span>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.idade_media_dependente_masculino != null">
              <span class="stat-bar-name">Masculino</span>
              <span class="stat-bar-value">{{ currentConjugesDependentes.idade_media_dependente_masculino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-male" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
            <div class="stat-bar-row" *ngIf="currentConjugesDependentes.idade_media_dependente_feminino != null">
              <span class="stat-bar-name">Feminino</span>
              <span class="stat-bar-value">{{ currentConjugesDependentes.idade_media_dependente_feminino | number:'1.0-1' }}</span>
              <div class="stat-bar-track"><div class="stat-bar-fill bar-female" [style.width.%]="50"></div></div>
              <span class="stat-bar-pct">( 50% )</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </ng-container>
  </div>
  <!-- fim #tabContent -->

    </div>
  </div>
</div>

<div *ngIf="loading" class="loading-container">
  <p>Carregando dados...</p>
</div>

<div *ngIf="!loading && !data" class="loading-container">
  <p>Não foi possível carregar os dados do relatório.</p>
</div>
